"use strict";

exports.__esModule = true;
exports.GalleryComponent = void 0;

var _react = _interopRequireDefault(require("react"));

var _GalleryContext = require("../context/GalleryContext.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var GalleryComponent =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(GalleryComponent, _React$Component);

  function GalleryComponent(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    if (typeof _this.context !== 'object') {
      _this.context = {};
    }

    if (props && typeof props.context === 'object') {
      _this.context = _objectSpread({}, _this.context, {}, props.context);
    }

    return _this;
  }

  return GalleryComponent;
}(_react["default"].Component);

exports.GalleryComponent = GalleryComponent;

_defineProperty(GalleryComponent, "contextType", _GalleryContext.GalleryContext);